export default __webpack_public_path__ + "static/media/mobileApp1.32c14a77.png";